import { gate } from 'hub-http/gates';
import { useGetIsUngated } from './useGetIsUngated';
export const useGetIsUngatedForTasksPlatformization = () => {
  const getIsUngated = useGetIsUngated();
  const isUngated = getIsUngated(gate('Tasks:CrmPlatform'));
  return isUngated;
};